/**
 * Kalendertage — in der Zeitzone, in der die Fahrer stehen.
 *
 * ═══ WARUM ES DIESE DATEI GIBT ═══
 *
 * `new Date().toISOString().slice(0, 10)` sieht aus wie „heute" und ist es
 * nicht: `toISOString` rechnet nach UTC. In der deutschen Sommerzeit (UTC+2)
 * liefert der Ausdruck zwischen 22:00 und Mitternacht den VORTAG.
 *
 * Das ist kein theoretischer Fall. Wer abends um halb elf die Tour für den
 * nächsten Morgen einträgt, bekäme ein Ladedatum von gestern — die Tour gälte
 * sofort als „Tour offen" statt „Geplant" und stünde beim Fahrer am falschen
 * Tag in der Liste. Genauso fallen abends die Arbeitstage des laufenden Tages
 * aus den „Offenen Punkten", weil die obere Grenze der Abfrage schon auf
 * gestern steht.
 *
 * Deshalb wird der Kalendertag hier aus den ÖRTLICHEN Feldern gebildet und
 * nirgends sonst im Backoffice aus einem Zeitstempel geschnitten.
 */

/** Ein Datum als `JJJJ-MM-TT` — nach der Uhr des Rechners, nicht nach UTC. */
export function alsTag(zeitpunkt: Date): string {
  const jahr = zeitpunkt.getFullYear();
  const monat = String(zeitpunkt.getMonth() + 1).padStart(2, '0');
  const tag = String(zeitpunkt.getDate()).padStart(2, '0');
  return `${jahr}-${monat}-${tag}`;
}

/** Der heutige Kalendertag. */
export function heute(): string {
  return alsTag(new Date());
}

/** Der Kalendertag, der so viele Tage zurückliegt (negativ) oder vorausliegt. */
export function tagVerschoben(tage: number): string {
  const wann = new Date();
  wann.setDate(wann.getDate() + tage);
  return alsTag(wann);
}

/**
 * Ein Wert, der ein Tag ODER ein Zeitpunkt sein kann, als Millisekunden.
 *
 * In den offenen Punkten steht beides in derselben Spalte: ein Ladedatum
 * (`2026-10-05`) neben `erkannt_am` (`2026-10-05T08:12:00+00:00`). Als Text
 * verglichen stimmt die Reihenfolge nur, solange beide zufällig gleich
 * aufgebaut sind. Ein reiner Tag gilt als örtlicher MITTAG — dieselbe Regel,
 * mit der die Seite „seit 3 Tagen" ausrechnet. So zeigen Anzeige und
 * Reihenfolge nie Verschiedenes.
 */
export function zeitpunktVon(wert: string): number {
  return new Date(wert.length === 10 ? wert + 'T12:00:00' : wert).getTime();
}
